"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useEscape;

var _react = require("react");

function useEscape(_ref) {
  var unless = _ref.unless,
      onPress = _ref.onPress;
  (0, _react.useEffect)(function () {
    function handleOnPress(e) {
      var shouldNotExecute = typeof unless === 'function' ? unless(e) : unless;

      if (shouldNotExecute || e.key !== 'Escape') {
        return;
      }

      onPress(e);
    }

    document.addEventListener('keyup', handleOnPress);
    return function () {
      document.removeEventListener('keyup', handleOnPress);
    };
  }, [unless]);
}